import React, { Component } from 'react';
import './App.css';
import 'react-tooltip/dist/react-tooltip.css'
import DemoCreatorWidget from './pages/DemoCreatorWidget'
import StatusChecker from './pages/StatusChecker'
import SitemapFilter from './pages/SitemapFilter'
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";


class App extends Component {
  render() {
    return (
      <div className="App flex justify-center items-center overflow-x-hidden" style={{ minHeight: '100%', height: '100%' }}>
        <BrowserRouter basename="/">
          <Routes>
            <Route path="/" element={<DemoCreatorWidget />} />
            <Route path="/status-checker/:email" element={<StatusChecker />} />
            <Route path="/sitemap-filter" element={<SitemapFilter />} />
          </Routes>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
